import React from 'react';
import PropTypes from 'prop-types';
import ClampLines from '../ClampLines/ClampLines';

import { getTranslation } from '../../providers/TranslationProvider';
import Button from '../Button';
import Link from '../Link';

import './ListCard.scss';
import ProfilePhoto from '../ProfilePhoto';
import handleCreatedByText from '../../utils/handleCreatedByText';

const ListCard = (props) => {
  const {
    createdBy, onClick, titleText, venueCountText, iconComponent, isCreateList, isLoading,
  } = props;

  const renderSubContent = () => {
    if (createdBy) {
      const { display, profilePicture } = createdBy;
      return (
        <div className="ListCard__created-by">
          <div className="ListCard__created-by-profile-pic">
            <ProfilePhoto url={profilePicture} size={20} />
          </div>
          <div className="ListCard__created-by-content">
            {`${handleCreatedByText(display)} • ${venueCountText}`}
          </div>
        </div>
      );
    }

    return venueCountText;
  };

  const renderCreateCard = () => (
    <Button
      variant="no-style"
      onClick={onClick}
      data-test-id="list_card-button-create_list"
      className="ListCard__Container ListCard__Container__CreateList"
    >
      <div className="ListCard__Background ListCard__CreateList">
        <div className="ListCard__IconWrapper">{iconComponent}</div>
        <div className="ListCard__TextContainer">
          <div className="ListCard__HeaderText ListCard__CreateListText--Desktop">
            {getTranslation({
              translationKey: 'lists.create_list',
              fallback: 'Create List',
            })}
          </div>
        </div>
      </div>
      <div className="ListCard__TextContainer">
        <div className="ListCard__HeaderText ListCard__CreateListText--Mobile">
          {getTranslation({
            translationKey: 'lists.create_list',
            fallback: 'Create List',
          })}
        </div>
      </div>
    </Button>
  );

  const renderListCard = () => (
    <Link
      variant="no-style"
      onClick={onClick}
      aria-label={`${titleText} ${venueCountText}`}
      data-test-id="list_card-button-create_list"
      className="ListCard__Container ListCard__Container__CreateList"
    >
      <div className="ListCard__Background">
        <div className="ListCard__IconWrapper fill">{iconComponent}</div>
      </div>
      <div className="ListCard__TextContainer">
        <div className="ListCard__HeaderText">
          <ClampLines
            text={titleText}
            id={`ListCard--title-${titleText.replaceAll(' ', '-')}`}
            lines={2}
            buttons={false}
          />
        </div>
        {venueCountText && (
        <div className="ListCard__VenueCountText">{renderSubContent()}</div>
        )}
      </div>
    </Link>
  );

  if (isLoading) {
    return (
      <div className="ListCard">
        <div className="ListCard__Container">
          <div className="ListCard__Background skeleton">
            <div className="ListCard__IconWrapper fill" />
          </div>
          <div className="ListCard__TextContainer">
            <div className="ListCard__HeaderText skeleton">&nbsp;</div>
            <div className="ListCard__VenueCountText skeleton">&nbsp;</div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="ListCard">
      {isCreateList && renderCreateCard()}
      {!isCreateList && renderListCard()}
    </div>
  );
};

ListCard.propTypes = {
  createdBy: PropTypes.shape({
    display: PropTypes.string,
    profilePicture: PropTypes.string,
  }),
  onClick: PropTypes.func.isRequired,
  isCreateList: PropTypes.bool,
  isLoading: PropTypes.bool,
  titleText: PropTypes.string.isRequired,
  venueCountText: PropTypes.string,
  checkmarkState: PropTypes.shape({
    checked: PropTypes.bool.isRequired,
  }),
  iconComponent: PropTypes.element.isRequired,
};

ListCard.defaultProps = {
  createdBy: undefined,
  isCreateList: false,
  isLoading: false,
  venueCountText: undefined,
  checkmarkState: undefined,
};

ListCard.displayName = 'ListCard';
export default ListCard;
